import React, { Component } from 'react'
import UsuarioVisitante from './components/UsuarioVisitante'





export class Inicio extends Component {

   
render() {
    return (

                <UsuarioVisitante></UsuarioVisitante>
        )
    }
}

export default Inicio
